@if (_document) {
  <div>
    <document-lines-editor
      #lineGrid
      [title]="'Doc::InventoryCount:Lines' | abpLocalization"
      [canAddLines]="false"
      [deleteActionEnabled]="false"
      [columnDefs]="columnDefs"
      [rows]="_document.lines"
      [onCellValueChanged]="onCellValueChanged"
      [readonly]="_readonly"
      [canExportLines]="true"
    ></document-lines-editor>
  </div>
}
